import Swal from 'sweetalert2';

/**
 * Loader con progress bar TEMPORIZZATA, pensato per le generazioni gpt-image-2
 * (lente, ~3-4 min) dove una barra tarata sulle feature veloci (~16s) sarebbe
 * fuorviante.
 *
 * La barra avanza linearmente da 0% fino a un massimo del 95% nell'arco di
 * `durationMs`, poi resta lì finché non si chiama `complete()` (100%): così
 * non arriva mai al 100% prima che l'immagine sia davvero pronta. I messaggi
 * ciclano sullo stesso arco temporale.
 *
 * @param {Object} opts
 * @param {string} [opts.title]
 * @param {Array<{icon:string,text:string}>} [opts.messages]
 * @param {number} [opts.durationMs=230000] tempo stimato della generazione.
 * @returns {{ complete: () => void, close: () => void }}
 */
export function startTimedLoader({
  title = 'Elaborazione in corso',
  messages = [{ text: 'Elaborazione in corso...' }],
  durationMs = 230000,
} = {}) {
  let progressTimer;
  let messageTimer;

  Swal.fire({
    title,
    html: `
      <div class="ai-timed-loader">
        <div class="ai-timed-status" style="display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:12px;">
          ${
            messages[0].icon
              ? `<span class="ai-timed-icon" style="font-size:1.3em;">${messages[0].icon}</span>`
              : ''
          }
          <span class="ai-timed-text">${messages[0].text}</span>
        </div>
        <div style="background:#eee;border-radius:8px;height:10px;overflow:hidden;">
          <div class="ai-timed-fill" style="height:100%;width:0%;background:linear-gradient(90deg,#278e8e,#3bb0b0);transition:width .6s ease;"></div>
        </div>
        <div style="margin-top:10px;font-size:0.85em;color:#777;">Non chiudere questa pagina durante l’elaborazione</div>
      </div>
    `,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      const container = Swal.getHtmlContainer();
      const fill = container && container.querySelector('.ai-timed-fill');
      const icon = container && container.querySelector('.ai-timed-icon');
      const text = container && container.querySelector('.ai-timed-text');

      const startTime = performance.now();
      progressTimer = setInterval(() => {
        const ratio = Math.min((performance.now() - startTime) / durationMs, 1);
        if (fill) {
          fill.style.width = `${Math.min(95, ratio * 95)}%`;
        }
      }, 500);

      if (messages.length > 1) {
        const step = durationMs / messages.length;
        let i = 0;
        messageTimer = setInterval(() => {
          i = Math.min(i + 1, messages.length - 1);
          if (icon && messages[i].icon) icon.textContent = messages[i].icon;
          if (text) text.textContent = messages[i].text;
        }, step);
      }
    },
    willClose: () => {
      clearInterval(progressTimer);
      clearInterval(messageTimer);
    },
  });

  return {
    // Porta la barra al 100% (immagine pronta).
    complete: () => {
      const container = Swal.getHtmlContainer();
      const fill = container && container.querySelector('.ai-timed-fill');
      if (fill) {
        fill.style.width = '100%';
      }
    },
    close: () => {
      clearInterval(progressTimer);
      clearInterval(messageTimer);
      Swal.close();
    },
  };
}
